import polygonDialog from "./polygonDialog";
import canvasMessages from "./canvasMessages";
import contextMenuList from "./contextMenuList";
import treeRender from "./treeRender";
import nodeStyle from "./nodeStyle";

export default {
  loading: {
    text: "拼命加载中",
  },
  // TopSearch.vue - 顶部时间搜索
  topSearch: {
    transactionTime: "交易时间",
    startDatePlaceholder: "开始日期",
    endDatePlaceholder: "结束日期",
  },
  // setupConfigure.vue - 设置配置
  setupConfigure: {
    title: "设置",
    transactionQuantityLabel: "交易数量（单笔交易）",
    minAmountPlaceholder: "最小金额",
    maxAmountPlaceholder: "最大金额",
    transactionTimeLabel: "交易时间",
    startDatePlaceholder: "开始日期",
    endDatePlaceholder: "结束日期",
    advancedSettingsTitle: "高级设置",
    expandCountLabel: "扩展对手数",
    expandCountPlaceholder: "1-100",
    expandCountError: "请填写1-100之间的整数",
    repeatAddressLabel: "重复地址标识",
    firstInflowEnable: "首笔主币流入",
    cancelBtn: "取消",
    confirmBtn: "确认",
  },
  // LeftOperation.vue - 左侧操作
  leftOperation: {
    settingsTooltip: "设置",
    aiModelTooltip: "AI模型",
    investigationTooltip: "调证",
  },
  // BTCAddress.vue - BTC地址详情
  btcAddress: {
    title: "地址详情",
    loadingText: "拼命加载中",
  },
  // BottomOperation.vue - 底部操作
  bottomOperation: {
    backToCenterTooltip: "回到中心",
    previousStepTooltip: "上一步",
    nextStepTooltip: "下一步",
    saveCanvasTooltip: "保存画布",
    fullscreenTooltip: "全屏",
    exitFullscreenTooltip: "取消全屏",
  },
  dialog: {
    canvasDownload: "画布下载",
    remark: "备注",
    addMonitoring: "添加监控",
    tip: "提示",
  },
  tips: {
    svgViewerTip:
      "为了获得最佳的查看体验，建议使用 Google Chrome 或 Microsoft Edge 浏览器打开SVG格式文件",
    verificationResult: "已有验证结果",
    switchCurrencyWarning: "切换币种后当前画布将不存在，是否需要保存画布？",
    searchAddressWarning:
      "搜索地址在画布中不存在，重新搜索后会打开新的画布，是否需要保存当前画布？",
  },
  buttons: {
    confirmDownload: "确认下载",
    close: "关闭",
    cancel: "取 消",
    confirm: "确 定",
    notSave: "不保存",
    saveCanvas: "保存画布",
    closeDialog: "关闭弹窗",
    viewVerification: "查看验证结果",
  },
  placeholders: {
    remarkInput: "请输入备注内容",
  },
  messages: {
    setupSuccess: "设置成功",
    createCanvasSuccess: "新建画布成功",
    saveSuccess: "保存成功",
    cancelled: "已取消",
  },
  titles: {
    modifyInfo: "修改信息",
  },
  canvasHeader: {
    unnamedCanvas: "未命名画布",
    singleCurrencyCanvas: "单币种画布",
    caseLabel: "案件：",
    selectCurrencyPlaceholder: "请选择币种",
    searchPlaceholder: "搜索地址/哈希",
    startAnalysis: "开始分析",
    shortcutKeys: "快捷键说明",
    svgFormat: "SVG格式",
    pngFormat: "PNG格式",
    xmindFormat: "XMIND格式",
    refresh: "刷新",
    save: "保存",
    shortcutKeysTitle: "画布操作快捷键说明",
    shortcuts: {
      copyNode: "复制节点",
      previousStep: "上一步",
      nextStep: "下一步",
      saveCanvas: "保存画布",
      createCanvas: "新建画布",
      nodeRemark: "节点备注",
      viewNodeDetail: "查看节点详情（选中单个点）",
      exitFullscreen: "退出画布全屏",
      addMonitoring: "加入监控",
    },
  },
  // modeldetail.vue - AI模型详情
  modelDetail: {
    title: "AI模型",
    loadingText: "拼命加载中",
    emptyText: "暂无数据",
    modelVerificationType: "模型验证类型：",
    feeModel: "手续费模型",
    verificationResult: "验证结果：",
    firstFeeSourceLevel: "首笔手续费来源层级：",
    feeSourceLevel: "手续费来源层级：",
    firstFeeSourcePlatform: "首笔手续费来源平台：",
    firstFeeSourceAddress: "首笔手续费来源地址：",
    feeSourceAddress: "手续费来源地址：",
    firstFeeSourceHash: "首笔手续费来源hash：",
    feeSourceHash: "手续费来源hash：",
    firstFeeSourceTime: "首笔手续费来源时间：",
    feeSourceTime: "手续费来源时间：",
    firstFeeSourceQuantity: "首笔手续费来源数量：",
    feeSourceQuantity: "手续费来源数量：",
    ordinaryInvestigation: "普通调证",
    keyInvestigation: "重点调证",
    copySuccess: "复制成功",
    addInvestigationSuccess: "加入调证成功",
  },
  // nodedetail.vue - 节点详情
  nodeDetail: {
    loadingText: "拼命加载中",
    addressDetail: "地址详情",
    nodeDetail: "节点详情",
    contractDetail: "合约详情",
    transactionStatistics: "交易统计",
    tradingOpponent: "交易对手",
    tradingOpponentWithUSDT: "交易对手(USDT)",
    otherInfo: "其他信息",
    assets: "资产",
    notSupportedBlockchain: "系统暂不支持此链上的数据展示",
    addressNotFound: "没有查出该地址",
    noTransactionData: "系统中没有当前地址的交易数据",
  },
  polygonDialog,
  canvasMessages,
  contextMenuList,
  treeRender,
  nodeStyle,
};
